<template>
    <modal
        :close="close"
        :printButton="true"
        :downloadButton="true"
    >
        <span slot="modalHeader">Сведения из реестра недобросовестных поставщиков</span>
        <div class="unfair-content" slot="modalBody">
            <div v-if="isActual">
                <h2 class="unfair-title">Актуальные сведения</h2>
                <ul class="unfair-list">
                    <li v-for="e in actualList">
                        C {{dateParser(e.unfair_date) }} контрагент включён в реестр недобросовестных поставщиков.
                        Причина включения в реестр: {{ e.reason }} 
                        <span v-if="e.guid_link">(<a :href="e.guid_link" target="_blank">Закупка: {{ e.purchase_number }}</a>)</span>
                        <span v-else>(Закупка: {{ e.purchase_number }})</span>
                    </li>
                </ul>
            </div>
            <div v-if="isArchive">
                <h2 class="unfair-title">Архивные сведения (на данный момент по ним исключён из реестра)</h2>
                <ul class="unfair-list">
                    <li v-for="e in archiveList">
                        C {{dateParser(e.unfair_date) }} контрагент был включён в реестр недобросовестных поставщиков.
                        Причина включения в реестр: {{ e.reason }} 
                        <span v-if="e.guid_link">(<a :href="e.guid_link" target="_blank">Закупка: {{ e.purchase_number }}</a>)</span>
                        <span v-else>(Закупка: {{ e.purchase_number }})</span>
                    </li>
                </ul>
            </div>
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
export default {
    components: { modal },
    props: ['actualList', 'archiveList', 'close'],
    computed: {
        isActual() { return !!this.actualList?.length },
        isArchive() { return !!this.archiveList?.length }
    }
}
</script>

<style lang="sass" scoped>
    .unfair-content
        padding: 15px
    .unfair-list
        display: flex
        flex-direction: column
        gap: 15px
    .unfair-title
        border-bottom: 1px solid #ddd
</style>